export type SortField = 'category' | 'indicator' | 'score' | 'unit' | null;
export type SortDirection = 'asc' | 'desc' | null;

export enum sortFields {
  CATEGORY = 'category',
  INDICATOR = 'indicator',
  SCORE = 'score',
  UNIT = 'unit',
}

export enum sortDirections {
  ASC = 'asc',
  DESC = 'desc',
}
